import {
  CheckoutItem,
  Offer,
} from "common/api/decimal/methods/compareAndPurchase.ts";
import { useIntl } from "react-intl";

function isOffer(item: Offer | CheckoutItem): item is Offer {
  return (item as Offer).tempBookItemId !== undefined;
}

export default function ItemCondition({
  item,
  className,
}: {
  className?: string;
  item: Offer | CheckoutItem;
}) {
  const intl = useIntl();
  const condition = isOffer(item) ? item.fcondition : item.condition;
  const getStatusMessage = () => {
    if (item.variant === "new") {
      return intl.formatMessage({ defaultMessage: "New" });
    } else if (item.variant === "used") {
      if (condition) {
        return intl.formatMessage(
          { defaultMessage: "Used, {condition}" },
          { condition }
        );
      } else {
        return intl.formatMessage({ defaultMessage: "Used" });
      }
    }
  };
  const statusMessage: string | undefined = getStatusMessage();

  if (statusMessage) {
    return <div className={className}>{statusMessage}</div>;
  }
}
